import React from 'react';
import useOnlineStatus from '../hooks/useOnlineStatus';

const OfflineIndicator = ({ language }) => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-auto bg-red-600 text-white px-4 py-2 rounded-md shadow-lg z-50">
      <div className="flex items-center">
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21.193 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m2.829 2.829l2.828 2.829M5.636 5.636a9 9 0 0112.728 0m0 0l-2.829 2.829m2.829-2.829L21 3M8.464 8.464a5 5 0 017.072 0m0 0l-2.829 2.829m2.829-2.829l2.829-2.829" />
        </svg>
        <span>
          {language === 'en' ? 'No internet connection' : 'इंटरनेट कनेक्शन नहीं है'}
        </span>
      </div>
    </div>
  );
};

export default OfflineIndicator;